import { createSignal, For } from 'solid-js'

const [messages, setMessages] = createSignal([])

export function addToast({ level, message, timeout }) {
  if (level) {
    console.assert(['info', 'success', 'warning', 'error'].indexOf(level) > -1)
  }
  const msg = { id: window.crypto.randomUUID(), level: level ?? 'success', message }
  setMessages(e => {
    e.push(msg)
    while (e.length > 10) {
      e.shift()
    }
    return [...e]
  })
  setTimeout(() => setMessages(e => {
    const i = e.findIndex(m => m.id === msg.id)
    if (i > -1) {
      e.splice(i, 1)
    }
    return [...e]
  }), timeout ?? 3000)
}

export default function Toast() {
  return (
    <div class="toast">
      <For each={messages()} fallback={<></>}>
        {(e) => (
          <>
            {e.level === 'info' && <div class="alert alert-info text-white">{e.message}</div>}
            {e.level === 'success' && <div class="alert alert-success text-white">{e.message}</div>}
            {e.level === 'warning' && <div class="alert alert-warning">{e.message}</div>}
            {e.level === 'error' && <div class="alert alert-error text-white">{e.message}</div>}
          </>
        )}
      </For>
    </div>
  )
}
